import {
    Box,
    Stack,
    useTheme
} from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
// import TabPanel from '@mui/lab/TabPanel';
import CircularProgress from '@mui/material/CircularProgress';

import { useState, useEffect } from 'react';
import useResponsive from "../../hooks/useResponsive";
import {observer} from "mobx-react-lite";
import ProviderService from "../../services/ProviderService";


import Header from "../../components/Header";
import Provider from "./Provider";

const AppAnalytics = () => {
    const [loading, setLoading] = useState(false);
    const [providers, setProviders] = useState([]);
    const isMobile = useResponsive("between", "md", "xs", "sm");

    useEffect(() => {
        handleUpdateProviders()
    }, []);  

    const handleUpdateProviders = () => {
        const fetcher = async () => {
            setLoading(false) 
            try {
                const providers = await ProviderService.getProviders();
                setProviders(providers.data.providers)
                setValue(providers.data.providers[0].id)
                setLoading(true) 
            } catch (e) {
                console.log(e);
                setLoading(true) 
            }
        };
        return fetcher()
    }

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box 
            ml= {isMobile ? "0px" : "20px"}
            mr= {isMobile ? "0px" : "20px"}
        >
            {/* HEADER */}
            {!isMobile && 
                <Box display="flex" justifyContent="space-between" alignItems="center" height={'100px'}>
                    <Header title="Analytics" subtitle="analytics" />
                </Box>
            }
            {/* CONTEXT */}
            <Stack spacing={2}>
                {loading
                    ?   <>
                        {providers.length > 1 && (
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                    {providers.map((provider) => {
                                        return <Tab value={ provider.id } label={provider.name} wrapped/>
                                    })}
                                </Tabs>
                            </Box>
                        )}
                        {value && <Provider provider={providers.find(provider => provider.id === value)}/>}
                        </>
                    :
                        <Box sx={{display: 'flex', justifyContent: 'center', p: 3 }}>
                            <CircularProgress color="primary" />
                        </Box>
                }
                
            </Stack>
        </Box>
    )
};
export default observer(AppAnalytics);